import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { RecurringTripOccurrence, RecurringTripSchedule, RecurringTripSchedulePayload } from '../models/recurring-trip.model';
import { normalizeApiArray } from '../utils/api-response.util';

@Injectable({ providedIn: 'root' })
export class RecurringTripService {
  private readonly apiUrl = `${environment.apiUrl}/RecurringTripSchedule`;

  constructor(private http: HttpClient) {}

  getSchedules(filter: { organisationId?: number | null; includeInactive?: boolean } = {}): Observable<RecurringTripSchedule[]> {
    let params = new HttpParams();
    if (filter.organisationId) params = params.set('organisationId', String(filter.organisationId));
    if (filter.includeInactive) params = params.set('includeInactive', 'true');
    return this.http.get<unknown>(this.apiUrl, { params }).pipe(
      map(response => normalizeApiArray<RecurringTripSchedule>(response))
    );
  }

  createSchedule(payload: RecurringTripSchedulePayload): Observable<RecurringTripSchedule> {
    return this.http.post<RecurringTripSchedule>(this.apiUrl, payload);
  }

  updateSchedule(id: number, payload: RecurringTripSchedulePayload): Observable<RecurringTripSchedule> {
    return this.http.put<RecurringTripSchedule>(`${this.apiUrl}/${id}`, payload);
  }

  deactivateSchedule(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  generateTrips(id: number, daysAhead = 30, maxOccurrences = 60): Observable<RecurringTripOccurrence[]> {
    return this.http.post<unknown>(`${this.apiUrl}/${id}/generate`, { daysAhead, maxOccurrences }).pipe(
      map(response => normalizeApiArray<RecurringTripOccurrence>(response))
    );
  }
}
